import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import ArrowLeftIcon from '@/assets/nav-arrow-left.svg?react';

const Breadcrumbs = () => {
  return (
    <Root>
      <StyledLink to="/admin/markets">
        <ArrowLeftIcon />
        <FormattedMessage
          id="backToMarketsAdmin"
          defaultMessage="Back to Markets Admin"
        />
      </StyledLink>
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  background: theme.palette.grey100,
  width: '100%',
  height: 88,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: `0 40px`,
  fontWeight: 600,
  fontSize: 14,
  borderBottom: `1px solid ${theme.palette.grey200}`,
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.textGray,
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default Breadcrumbs;
